import styled from "styled-components";
import {hexToRgba} from "../../../../../themes/hex-to-rgba";
import {SideMenuItemsListDefaultBox} from "./side-menu-items-list.default.box";

export const SideMenuItemsListMrGreenBox = styled(SideMenuItemsListDefaultBox)`
    border-bottom: 1px solid ${({theme}) => hexToRgba(theme.colors.boxBorderLighter, 0.2)};
    border-radius: 0;

    &:last-child {
        border-bottom: none;
    }
`;
